import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import Header from "../../components/Header";
import { getSpecialistDoctorById } from "./../../ApiConfig.jsx";

function ViewSpecialistDoctor() {
  const { id } = useParams();
  const [itemDetails, setItemDetails] = useState({});
  const fetchData = async (id) => {
    try {
      const data = await getSpecialistDoctorById(id);
      console.log("🚀 ~ fetchData ~ data:", data)
      if (data.success) {
        console.log(data.data);
        setItemDetails({
          Name: data.data.name,
          Field: data.data.field === "md" ? "MD" : "Assist MD",
          "Professional Id": data.data.professionalId,
          Hospital: data.data.hospital.name,
          Type: data.data.hospital.type === "public" ? "Public" : "Private",
          Address: data.data.hospital.address,
          Phone: data.data.phone,
          Email: data.data.email,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`View Specialist Doctor ${id}`} subtitle="" />
      <Box ml={"40px"}>
        <Grid container spacing={2}>
          {Object.entries(itemDetails).map(([field, value]) => (
            <React.Fragment key={field}>
              <Grid item xs={3}>
                <Typography variant="h5" component="span" fontWeight="bold">
                  {field}:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>{value}</Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default ViewSpecialistDoctor;
